import { Component, MeshComponent, Object3D, TextComponent } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { CursorTarget } from '@wonderlandengine/components';
import { Inventory } from './inventory.js';
import { TextFade } from './text-fade.js';
import { LevelManagerScene2 } from '../scene2/level-manager-scene2.js';
import { FlatMaterial } from '../types/materials.js';

/**
 * murder-image
 */
export class MurderImage extends Component {
    static TypeName = 'murder-image';

    @property.object({ required: true })
    player!: Object3D;

    @property.object({ required: true })
    stringParent!: Object3D;

    private cursorTarget?: CursorTarget;
    private text?: Object3D;
    private levelManager?: Object3D;
    private stringActivated = false;
    private activeMeshes = false;
    private stringNum = 0;
    private inventory?: Inventory;
    private textFade?: TextFade;

    start() {
        /* Add Cursor Functions */
        this.cursorTarget =
            this.object.getComponent(CursorTarget) ||
            this.object.addComponent(CursorTarget)!;

        const tempInventory = this.player.getComponent(Inventory);
        if (!tempInventory) {
            throw new Error(
                `murder-image(${this.object.name}): player does not have a Inventory`
            );
        }
        this.inventory = tempInventory;

        const tempTextFade = this.object.getComponent(TextFade);
        if (!tempTextFade) {
            throw new Error(
                `murder-image(${this.object.name}): object does not have a TextFadetempTextFade`
            );
        }
        this.textFade = tempTextFade;


        this.text = this.object.children[0];
        const textComponent = this.text.getComponent(TextComponent);
        if (!textComponent) {
            throw new Error(
                `murder-image(${this.text.name}): objecgt does not have a TextComponent`
            );
        }
        const childTextMaterial = textComponent.material as FlatMaterial;
        childTextMaterial.color = [1, 1, 1, 0];

        this.levelManager = this.inventory.levelManager;
        this.stringActivated = false;

        /* Strings Attach (Deactive) */
        if (this.stringParent == null) {
            return
        }
        for (const child of this.stringParent.children) {
            /* Deactive children */
            if (child.getComponent(MeshComponent)) {
                child.getComponent(MeshComponent)!.active = false;
            }
            /* Deactive children of children */
            for (const c of child.children) {
                if (c.getComponent(MeshComponent)) {
                    c.getComponent(MeshComponent)!.active = false;
                }
            }
        }
    }

    onActivate(): void {
        this.cursorTarget!.onHover.add(this.onHover);
        this.cursorTarget!.onUnhover.add(this.onUnHover);
        this.cursorTarget!.onDown.add(this.onDown);
    }

    onDeactivate(): void {
        this.cursorTarget!.onHover.remove(this.onHover);
        this.cursorTarget!.onUnhover.remove(this.onUnHover);
        this.cursorTarget!.onDown.remove(this.onDown);
    }

    onHover = () => {
        if (this.inventory!.stringsActiveNum == 4) {
            return
        }
        this.textFade!.fadeIn();
    }

    onUnHover = () => {
        // if (this.inventory!.stringsActiveNum == 4) {
        //     this.textFade!.textObj.getComponent('text').material.color = [1, 1, 1, -0.5];
        // } else {
        this.object.getComponent(TextFade)?.fadeOut();
        //}
    }

    onDown = () => {
        /* Gate */
        if (this.stringParent == null) {
            return
        }
        if (this.inventory!.stringsActiveNum == 4) {
            return
        }

        /* Toggle Activation */
        if (this.stringActivated) {
            /* Deactive */
            this.activeMeshes = false;
            this.stringNum = -1;
        } else {
            /* Active */
            this.activeMeshes = true;
            this.stringNum = 1;
        }

        /* Strings Attach (Active) */
        for (const child of this.stringParent.children) {
            /* Active children */
            if (child.getComponent(MeshComponent)) {
                child.getComponent(MeshComponent)!.active = this.activeMeshes;
            }
            /* Active children of children */
            for (const c of child.children) {
                if (c.getComponent(MeshComponent)) {
                    c.getComponent(MeshComponent)!.active = this.activeMeshes;
                }
            }
        }

        /* Add to Inventory */
        if (this.object.name == "Image_murder04") {
            this.inventory!.stringsActiveNum -= this.stringNum; /* Remove 1 from inventory as it's Wrong Image Picked */
        } else {
            this.inventory!.stringsActiveNum += this.stringNum;
        }
        this.levelManager!.getComponent(LevelManagerScene2)!.checkStrings(
            this.inventory!.stringsActiveNum);

        /* Toggle Activation */
        this.stringActivated = !this.stringActivated;
    }

}
